module.exports = __webpack_public_path__ + "static/media/spock.70518acf.jpg";